const nativeBridge = require("./native")
const webBridge = require("./web")

module.exports = { nativeBridge, webBridge }
